module.exports = __webpack_public_path__ + "img/mazda-5050-full.19250058.jpeg";